import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import BiddingConsole from './BiddingConsole';
import BiddingHistory from './BiddingHistory';
import ListingDetail from './ListingDetails'
import BiddingRegistration from '../../common/BiddingRegistration';
import LoginModal from './../../common/LoginModal';
import axios from 'axios';
import { config } from '../../../utils/config';
import AuthContext from '../../authcontext/AuthContext';
// import CommonModal from '../../common/CommonModal';

export default function BiddingPage() {
  let { biddingId } = useParams();
  const [lastBidTime, setLastBidTime] = useState(null);
  const [paymentVerified, setPaymentVerified] = useState(false)
  const authData = useContext(AuthContext)

  useEffect(() => {

    const getBiddingData = async () => {

      await axios.get(`${config.apiBaseUrl}/bidsession`, {
        params: {
          bidId: biddingId
        }
      })
    }
    getBiddingData()

    console.log("console.log bidding id", biddingId)

  }, [lastBidTime, biddingId])

  const handleNewBid = () => {
    setLastBidTime(Date.now()); // Update lastBidTime whenever a new bid is made
  };

  useEffect(() => {

    const bidToken = authData.getClientToken()
    console.log("bidding page bid token", bidToken)
    const getPaymentData = async () => {

      try {
        const paymentData = await axios.get(`${config.apiBaseUrl}/payment/get_record`, {
          params: {
            bidToken
          }
        })

        const data = paymentData.data
        console.log("payment data", data)

        let check = false
        // Check if data is an array
        if (Array.isArray(data)) {
          // Use .find() to see if any object in the array has a matching bid_detail_id
          check = data.find(obj => obj.bid_detail_id === Number(biddingId)) !== undefined;
        } else if (data && data.bid_detail_id) {
          // If data is a single object, directly compare the bid_detail_id
          check = data.bid_detail_id === Number(biddingId);
        }

        console.log("check", check)
        if (check) {
          setPaymentVerified(true)
          // const timerId = setTimeout(() => {
          //   // Show the popup after 15 minutes
          //   setShowPopup(true);
          // }, 900000); // 900000 milliseconds = 15 minutes

          // // Clear timeout on component unmount
          // return () => clearTimeout(timerId);
        }
      } catch (error) {
        console.error("Error fetching payment data:", error);
      }
    }

    getPaymentData()
  }, [])

  return (
    <>

      <div className="container-fluid p-1" style={{ width: "90%" }}>
        <div>
          <ListingDetail id={biddingId} />
        </div>

        {authData.getIsAuth() ?
          <div className="row mt-2">
            <div className="col-sm-6 mt-3 pt-3">
              {/* need to insert this after payment detail is ready for retrieval authData.getClientToken() === biddingId ? */}
              {paymentVerified ?
                <BiddingConsole id={biddingId} onNewBid={handleNewBid} /> :
                <div className="d-flex justify-content-center">
                  <BiddingRegistration id={biddingId} />
                </div>
              }
            </div>
            <div className="col-sm-6">
              <BiddingHistory id={biddingId} />
            </div>
          </div>
          :
          <div className="d-flex justify-content-center">
            <LoginModal />
          </div>
        }
      </div>
      {/* <CommonModal title="Error" message="Please Check Your Username and Password" show={errorModal} handleClose={() => { setErrorModal(false) }}/> */}
    </>
  )
}

